import {View} from '@ab/components';
import tpl from './templates/interactive.jsx';
import {connect} from 'react-redux';
import {lang} from '../../actions';

class Footer extends View {
    template = tpl;

    _handleLangChange = event => {
        this.props.dispatch(lang(event.target.value));
    };

    static displayName = 'Footer';
}

const mapStateToProps = state => {
    return {lang: state.lang};
};

export default connect(mapStateToProps)(Footer);
